import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { UploadProvider } from './contexts/UploadContext';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import LoadingPage from './components/auth/LoadingPage';
import Dashboard from './components/Dashboard';
import KBHome from './components/KBHome';
import ManualUpload from './components/ManualUpload';
import Recordings from './components/Recordings';
import NavBar from './components/NavBar';
import OSCARPage from './pages/OSCARPage';
import E2DSL from './components/E2DSL';
import ChatWithLogs from './components/ChatWithLogs';
import AgenticObservability from './components/AgenticObservability';
import Feedback from './components/Feedback';
import Logout from './components/Logout';
import './App.css';
import './styles/E2DSL.css';
import './config/cognito';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <LoadingPage />;
  }

  return currentUser ? (
    <div className="app-layout">
      <NavBar />
      <main className="main-content">
        {children}
      </main>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

const AppRoutes = () => {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <AgenticObservability />
              </PrivateRoute>
            }
          />
          <Route
            path="/recordings"
            element={
              <PrivateRoute>
                <Recordings />
              </PrivateRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <PrivateRoute>
                <ManualUpload />
              </PrivateRoute>
            }
          />
          <Route
            path="/kb"
            element={
              <PrivateRoute>
                <KBHome />
              </PrivateRoute>
            }
          />
          <Route
            path="/oscar"
            element={
              <PrivateRoute>
                <OSCARPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/e2dsl"
            element={
              <PrivateRoute>
                <E2DSL />
              </PrivateRoute>
            }
          />
          <Route
            path="/chat-with-logs"
            element={
              <PrivateRoute>
                <ChatWithLogs />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <PrivateRoute>
                <Feedback />
              </PrivateRoute>
            }
          />
          <Route
            path="/agentic-observability"
            element={
              <PrivateRoute>
                <AgenticObservability />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  // Log environment variables for debugging
  console.log('Environment:', process.env.NODE_ENV);
  console.log('Environment Variables:', {
    API_URL: process.env.REACT_APP_API_URL,
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    USER_POOL_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    REDIRECT_SIGNIN: process.env.REACT_APP_REDIRECT_SIGNIN
  });

  return (
    <AuthProvider>
      <UploadProvider>
        <AppRoutes />
      </UploadProvider>
    </AuthProvider>
  );
}

export default App;
